export default __webpack_public_path__ + "static/stile_x_quiz-19c797149bc44c06b0fd8dea82daab28.gif";